import { useIsBannerHidden } from 'hooks/useIsBannerHidden'
import React from 'react'
import { Route, Switch } from 'react-router'
import NotificationBanner from '../Header/HeaderBanners/NotificationBanner'

const HELP_NOTIFICATION_BANNER_ROUTES: Array<string> = [
  '/:regionCode/terms-and-conditions',
  '/:regionCode/account/my-escapes',
  '/:regionCode/account/my-escapes/order/:orderId',
]

function NotificationBannerRoutes() {
  const isHidden = useIsBannerHidden('notificationBanner')

  if (isHidden) {
    return null
  }

  return <Switch>
    <Route path={HELP_NOTIFICATION_BANNER_ROUTES}>
      <NotificationBanner slug="help-with-banner" />
    </Route>
    <Route component={NotificationBanner} />
  </Switch>
}

export default NotificationBannerRoutes
